module.exports = __webpack_public_path__ + "cd455783/img/link-icon.fa09ed66.svg";